module.exports = __webpack_public_path__ + "img/20200515_163339.c07f1912.jpg";